import { render } from "./updateLog.vue?vue&type=template&id=72767fce&scoped=true"
import script from "./updateLog.vue?vue&type=script&lang=js"
export * from "./updateLog.vue?vue&type=script&lang=js"

import "./updateLog.vue?vue&type=style&index=0&id=72767fce&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72767fce"]])

export default __exports__